import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	changeboarding: {
		id: 'issue-create.modal.create-form.status-field.changeboarding.changeboarding',
		defaultMessage:
			'You can now choose the status of your issue while creating it. For example, select In progress if you’ve started the work. You’ll only see statuses you have permission to use.',
		description: 'Spotlight text shown to non-site-admin users',
	},
	changeboardingAdmin: {
		id: 'issue-create.modal.create-form.status-field.changeboarding.changeboarding-admin',
		defaultMessage:
			'Choose the status of your issue while creating it. For example, select In progress if you’ve started the work. You can manage this field in {boldStart}System settings{boldEnd}.',
		description: 'Spotlight text shown to site-admin users',
	},
});
